<template>
  <input ref="input" v-model="filter" style="height: 20px" />
</template>

<script>
import Vue from 'vue'
import { cloneDeep } from 'lodash'

export default Vue.extend({
  data() {
    return {
      filter: '',
      type: null,
      filterType: null
    }
  },

  methods: {
    isFilterActive() {
      return !!this.filter
    },

    doesFilterPass() {
      return true
    },

    getModel() {
      const noFilter = [null, undefined].includes(this.filter) || !this.filter.toString().trim()

      if (noFilter) return null
      return { filterType: this.filterType, type: this.type, filter: this.filter }
    },

    setModel(model) {
      if (model) {
        this.filterType = model.filterType
        this.type = model.type
        this.filter = cloneDeep(model.filter)
      }
    },

    onFloatingFilterChanged(type, filter, filterType) {
      this.type = type
      this.filter = filter
      this.filterType = filterType
      this.params.filterChangedCallback()
    }
  }
})
</script>
